export class DriftService {
    init() {
        const t = (window.driftt = window.drift = window.driftt || []);
        window.drift.SNIPPET_VERSION = '0.3.1';

        if (!t.init) {
            if (t.invoked) {
                // eslint-disable-next-line no-void
                return void (window.console && console.error && console.error('Drift snippet included twice.'));
            }

            t.invoked = !0;
            t.methods = ['identify', 'config', 'track', 'reset', 'debug', 'show', 'ping', 'page', 'hide', 'off', 'on'];
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            t.factory = function (e) {
                return function () {
                    const n = Array.prototype.slice.call(arguments);
                    // eslint-disable-next-line no-sequences
                    return n.unshift(e), t.push(n), t;
                };
            };

            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            // eslint-disable-next-line
            t.methods.forEach((e) => (t[e] = t.factory(e)));
            t.load = function (providerKey: string) {
                const e = 3e5;
                const n = Math.ceil(+new Date() / e) * e;
                const o = document.createElement('script');
                o.type = 'text/javascript';
                o.async = !0;
                o.crossOrigin = 'anonymous';
                o.src = `https://js.driftt.com/include/${n}/${providerKey}.js`;
                const i = document.getElementsByTagName('script')[0];
                i.parentNode && i.parentNode.insertBefore(o, i);
            };
        }
    }

    private withDrift(fn: (drift: typeof window.drift) => void) {
        if (window.drift) {
            fn(window.drift);
        }
    }

    load(providerKey: string) {
        if (!window.drift) {
            this.init();
        }

        return new Promise<void>((resolve) =>
            this.withDrift((drift) => {
                drift.load(providerKey);
                drift.on('ready', () => resolve());
            }),
        );
    }

    openChat() {
        this.withDrift((drift) => drift.api.openChat());
    }

    page() {
        this.withDrift((drift) => drift.page());
    }
}
